import { svgs } from "public/assets/svgs"
import { Toaster as Sonner, toast } from "sonner"

export const iconConfig = {
  error: "redArrowIconToast",
  success: "greenArrowIconToast",
  warning: "yellowArrowIconToast",
  info: "redArrowIconToast",
  default: "redArrowIconToast",
} as const

export type ToasterProps = React.ComponentProps<typeof Sonner>

export const addProgressBarAndStyles = () => {
  const toasts = document.querySelectorAll("[data-sonner-toast]:not([data-progress-added])")

  toasts.forEach((toast) => {
    toast.setAttribute("data-progress-added", "true")

    const toastType = toast.getAttribute("data-type") || "default"

    const gradientMap: Record<string, string> = {
      success: "#00BA34aa",
      warning: "#F98600aa",
      error: "#E92C2Caa",
      info: "linear-gradient(90deg, #007BFFaa, #80c8ff)",
      default: "linear-gradient(90deg, #334289aa, #8fe480)",
    }

    const bgColors: Record<string, string> = {
      success: "#F2FBF5",
      warning: "#FEF9F2",
      error: "#FBF4F5",
      info: "#F0F8FF",
      default: "#F5F5F5",
    }

    const borderColors: Record<string, string> = {
      success: "#00BA334D",
      warning: "#F986004D",
      error: "#E92C2C24",
      info: "#007BFF33",
      default: "#33428933",
    }

    // Apply background and border
    const toastElement = toast as HTMLElement
    toastElement.style.backgroundColor = bgColors[toastType] || "#F5F5F5"
    toastElement.style.border = `1px solid ${borderColors[toastType]}`
    toastElement.style.borderBottom = "none"
    toastElement.style.boxSizing = "border-box"
    toastElement.style.width = "425px"

    // Add CSS for icon spacing and text styling if not already added
    if (!document.getElementById("toast-icon-spacing-styles")) {
      const style = document.createElement("style")
      style.id = "toast-icon-spacing-styles"
      style.textContent = `
          [data-sonner-toast] [data-icon] {
            margin-right: 12px !important;
            flex-shrink: 0;
            
          }
          [data-sonner-toast] {
            display: flex !important;
            gap: 12px !important;
            padding-top: 12px !important;
            padding-bottom: 14px !important;
          }
          [data-sonner-toast] [data-title] {
            font-weight: 700 !important;
            font-size: 14px !important;
            color: #000 !important;
            margin-bottom: 2px !important;
          }
          [data-sonner-toast] [data-description] {
            font-weight: 500 !important;
            font-size: 12px !important;
            color: #130E14A6 !important;
          }
                [data-sonner-toast] [data-title],
            [data-sonner-toast] [data-description] {
              font-family: var(--font-inter), sans-serif !important;
            }
        `
      document.head.appendChild(style)
    }

    const progressBar = document.createElement("div")
    progressBar.style.cssText = `
        position: absolute;
        bottom: 0;
        left: 0;
        height: 4px;
        width: 0%;
        background: ${gradientMap[toastType]};
        z-index: 50;
        pointer-events: none;
        transition: none;
      `

    const computedStyle = window.getComputedStyle(toast)
    if (computedStyle.position === "static") {
      toastElement.style.position = "relative"
    }
    toastElement.style.overflow = "hidden"

    toast.appendChild(progressBar)

    setTimeout(() => {
      progressBar.style.transition = "width 2s linear"
      progressBar.style.width = "100%"
    }, 10)
  })
}

export const createToast = (type: keyof typeof iconConfig, title: string, description: string) => {
  const gradientMap: Record<string, string> = {
    success: "#00BA34aa",
    warning: "#F98600aa",
    error: "#E92C2Caa",
    info: "linear-gradient(90deg, #007BFFaa, #80c8ff)", // Note: SVGs don't support gradients via `fill` unless defined
    default: "linear-gradient(90deg, #334289aa, #8fe480)",
  }

  const fillColor = gradientMap[type]

  const iconProps = { fill: fillColor, height: 25, width: 25 }

  const icon = svgs[iconConfig[type]]?.(iconProps)
  const options = { description, icon }

  if (type === "success" || type === "error" || type === "warning") {
    toast[type](title, options)
  } else {
    toast(title, options)
  }
}
